import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
/* Layout */
import i18n from "@/locales"; // internationalization
import Layout from "@/layout";
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
    path: "/agreement",
    component: () => import("@/views/about/agreement"),
    hidden: true,
    meta: {
      title: "Breadcrumb.text21",
      activeTitle: "",
    },
  }, {
    path: "/privacy",
    component: () => import("@/views/about/privacy"),
    hidden: true,
    meta: {
      title: "Breadcrumb.text22",
      activeTitle: "",
    },
  }, {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
    meta: {
      title: "用户登录",
      activeTitle: "",
    },
  }, {
    path: "/register",
    component: () => import("@/views/register/index"),
    hidden: true,
    meta: {
      title: "用户注册",
      activeTitle: "",
    },
  }, {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  }, {
    path: "/activity",
    component: Layout,
    children: [{
      path: "detail",
      name: "activity",
      component: () => import("@/views/activity/detail"),
      meta: {
        title: "Breadcrumb.text23",
        activeTitle: "",
        icon: "",
      },
    }, {
      path: "personInfoInRoom",
      name: "activity",
      component: () => import("@/views/activity/personInfoInRoom"),
      meta: {
        title: "Breadcrumb.text24",
        activeTitle: "",
        icon: "",
      },
    }, {
      path: "addperson",
      name: "activity",
      component: () => import("@/views/activity/addperson"),
      meta: {
        title: "Breadcrumb.text24",
        activeTitle: "",
        icon: "",
      },
    }],
  },
  // 个人中心
  {
    path: "/userInfo",
    component: Layout,
    children: [{
      path: "/userInfo/index",
      name: "UserInfo",
      component: () => import("@/views/userInfo/index"),
      meta: {
        title: 'Navbar.person',
        activeTitle: 'Navbar.person',
        icon: "",
      },
    }, ],
  },
  // 客服聊天
  {
    path: "/websocket",
    component: Layout,
    children: [{
      path: "/websocket/index",
      name: "websocket",
      component: () => import("@/views/websocket/index"),
      meta: {
        title: 'Navbar.aboutus',
        activeTitle: 'Navbar.aboutus',
        icon: "",
      },
    }, ],
  }, {
    path: "/aboutInfo",
    component: Layout,
    children: [{
      path: "/aboutInfo/index",
      name: "About",
      component: () => import("@/views/about/index"),
      meta: {
        title: 'Navbar.aboutus',
        activeTitle: 'Navbar.aboutus',
        icon: "",
      },
    }, ],
  }, {
    path: "/interests",
    component: Layout,
    meta: {
      title: 'Navbar.vip',
      activeTitle: 'Navbar.vip',
    },
    redirect: "/interests/index",
    children: [{
      path: "/interests/index",
      name: "Interests",
      component: () => import("@/views/interests/index"),
      meta: {
        title: 'Navbar.vip',
        activeTitle: 'Navbar.vip',
      },
    }, {
      path: "/meal/index",
      name: "Meal",
      component: () => import("@/views/meal/index"),
      meta: {
        title: 'Navbar.vipdetail',
        activeTitle: 'Navbar.vip',
        icon: "",
      },
    }, {
      path: "/kefu/index",
      name: "Kefu",
      component: () => import("@/views/kefu/index"),
      meta: {
        title: '客服聊天',
        activeTitle: '客服聊天',
        icon: "",
      },
    }, {
      path: "/meal/mealPurchase",
      name: "MealPurchase",
      component: () => import("@/views/meal/mealPurchase"),
      meta: {
        title: "Breadcrumb.text6",
        icon: "",
      },
    }, {
      path: "/meal/pay",
      name: "pay",
      component: () => import("@/views/meal/pay"),
      meta: {
        title: "Breadcrumb.text7",
        icon: "",
      },
    }, ],
  }, {
    path: "/forum",
    component: Layout,
    children: [{
      path: "/forum/index",
      name: "Forum",
      component: () => import("@/views/forum/index"),
      meta: {
        title: 'Navbar.community',
        activeTitle: 'Navbar.community',
        icon: "",
      },
    }, {
      path: "/forum/article",
      name: "Article",
      component: () => import("@/views/forum/article"),
      meta: {
        title: "Breadcrumb.text8",
        icon: "",
      },
    }, ],
  }, {
    path: "/entered",
    component: Layout,
    children: [{
      path: "/entered/index",
      name: "Entered",
      component: () => import("@/views/entered/index"),
      meta: {
        title: "Breadcrumb.text9",
        activeTitle: "机构入驻",
        icon: "",
      },
    }, ],
  }, {
    path: "/scheme",
    component: Layout,
    children: [{
      path: "/scheme/index",
      name: "Entered",
      component: () => import("@/views/scheme/index"),
      meta: {
        title: 'Navbar.form',
        activeTitle: 'Navbar.form',
        icon: "",
      },
    }, ],
  }, {
    path: "/activity",
    component: Layout,
    children: [{
      path: "/activity/index",
      name: "Entered",
      component: () => import("@/views/activity/index"),
      meta: {
        title: 'Navbar.activity',
        activeTitle: 'Navbar.activity',
        icon: "",
      },
    }, ],
  }, {
    path: "/shopCart",
    component: Layout,
    children: [{
      path: "/shopCart/shopCart",
      name: "ShopCart",
      component: () => import("@/views/shopCart/shopCart"),
      meta: {
        title: "Breadcrumb.text10",
        activeTitle: "购物车",
        icon: "",
      },
    }, ],
  }, {
    path: "/pay",
    component: Layout,
    children: [{
      path: "/pay/pay",
      name: "Pay",
      component: () => import("@/views/pay/pay"),
      meta: {
        title: "Breadcrumb.text11",
        icon: "",
      },
    }, ],
  }, {
    path: "/pay",
    component: Layout,
    children: [{
      path: "/pay/payment",
      name: "Pay",
      component: () => import("@/views/pay/payment"),
      meta: {
        title: "Breadcrumb.text11",
        icon: "",
      },
    }, ],
  },
  // 通用支付页面
  {
    path: "/payment",
    component: Layout,
    children: [{
      path: "pay",
      name: "Pay",
      component: () => import("@/views/common/payment"),
      meta: {
        title: "Breadcrumb.text11",
        icon: "",
      },
    }, ],
  },
  // 选择地址确认订单
  {
    path: "/purchase",
    component: Layout,
    children: [{
      path: "/purchase/purchase",
      name: "Pay",
      component: () => import("@/views/purchase/purchase"),
      meta: {
        title: "Breadcrumb.text12",
        icon: "",
      },
    }, ],
  },
  // 套餐
  // {
  //   path: '/meal',
  //   component: Layout,
  //   children: [{
  //       path: '/meal/index',
  //       name: 'Meal',
  //       component: () => import('@/views/meal/index'),
  //       meta: {
  //         title: '会员详情',
  //         icon: ''
  //       }
  //     }, {
  //       path: '/meal/mealPurchase',
  //       name: 'MealPurchase',
  //       component: () => import('@/views/meal/mealPurchase'),
  //       meta: {
  //         title: '会员套餐支付',
  //         icon: ''
  //       }
  //     },
  //   ]
  // },
  // 机构路由
  {
    path: "/agency",
    component: Layout,
    name: "Agency",
    meta: {
      title: "Breadcrumb.text1",
    },
    redirect: "/agency/list",
    children: [{
      path: "/agency/list",
      name: "AgencyList",
      component: () => import("@/views/agency/list"),
      meta: {
        title: 'Navbar.parner',
        activeTitle: 'Navbar.parner',
      },
      // meta: {
      //   title: '合作机构列表',
      //   icon: ''
      // }
    }, {
      path: "/agency/index",
      name: "Agency",
      component: () => import("@/views/agency/index"),
      meta: {
        title: "Breadcrumb.text3",
        icon: "",
      },
      children: [],
    }, {
      path: "/agency/tryOut",
      name: "TryOut",
      component: () => import("@/views/agency/tryOut"),
      meta: {
        title: "Breadcrumb.text4",
        icon: "",
      },
    }, {
      path: "/agency/evalList",
      name: "EvalList",
      component: () => import("@/views/agency/evalList"),
      meta: {
        title: "Breadcrumb.text13",
        icon: "",
      },
    }, {
      path: "/agency/evalDetail",
      name: "EvalDetail",
      component: () => import("@/views/agency/evalDetail"),
      meta: {
        title: "Breadcrumb.text14",
        icon: "",
      },
    }, ],
  },
  // 养老产品列表
  {
    path: "/healthManager",
    component: Layout,
    meta: {
      title: "Breadcrumb.text15",
    },
    redirect: "/healthManager/list",
    children: [{
      path: "/healthManager/list",
      name: "HealthList",
      component: () => import("@/views/healthManager/list"),
      meta: {
        title: 'Navbar.health',
        activeTitle: 'Navbar.health',
      },
      // meta: {
      //   title: '健康管理',
      //   icon: ''
      // }
    }, {
      path: "/healthManager/index",
      name: "HealthManager",
      component: () => import("@/views/healthManager/index"),
      meta: {
        title: "Breadcrumb.text16",
        icon: "",
      },
    }, ],
  }, {
    path: "/insurance",
    component: Layout,
    meta: {
      title: "Breadcrumb.text17",
    },
    redirect: "/insurance/index",
    children: [{
      path: "/insurance/index",
      name: "Insurance",
      component: () => import("@/views/insurance/index"),
      meta: {
        title: "Breadcrumb.text18",
        activeTitle: "专业保险",
      },
    }, {
      path: "/insurance/info",
      name: "Info",
      component: () => import("@/views/insurance/info"),
      meta: {
        title: "Breadcrumb.text19",
        activeTitle: "专业保险",
      },
    }, ],
  }, {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [{
      path: "dashboard",
      name: "Dashboard",
      component: () => import("@/views/dashboard/index"),
      meta: {
        title: 'Navbar.homedetail',
        activeTitle: 'Navbar.home',
      },
    }, ],
  }, {
    path: "/example",
    component: Layout,
    redirect: "/example/table",
    name: "Example",
    meta: {
      title: "example",
      icon: "el-icon-s-help",
    },
    children: [{
      path: "table",
      name: "Table",
      component: () => import("@/views/table/index"),
      meta: {
        title: "table",
        icon: "table",
      },
    }, {
      path: "tree",
      name: "Tree",
      component: () => import("@/views/tree/index"),
      meta: {
        title: "tree",
        icon: "tree",
      },
    }, ],
  }, {
    path: "/order_list",
    component: Layout,
    redirect: "/order_list/table",
    name: "Example",
    meta: {
      title: "order_list",
      icon: "el-icon-s-help",
    },
    children: [{
      path: "table",
      name: "Table",
      component: () => import("@/views/table/index"),
      meta: {
        title: "table",
        icon: "table",
      },
    }, {
      path: "tree",
      name: "Tree",
      component: () => import("@/views/tree/index"),
      meta: {
        title: "tree",
        icon: "tree",
      },
    }, ],
  }, {
    path: "/order",
    component: Layout,
    children: [{
      path: "/order/detail",
      name: "OrderDetail",
      component: () => import("@/views/order/detail"),
      meta: {
        title: "Breadcrumb.text20",
      },
    }, ],
  },
  // 404 page must be placed at the end !!!
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];
const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRoutes,
});
const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;